<template>
  <td>
    <button class="k-primary k-button k-grid-edit-command ml-2 " @click="editHandler">Edit</button>
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    editHandler: function() {
      this.$emit("edit", { dataItem: this.item });
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>
